<template>
  <v-menu
      :close-on-content-click="false"
      :disabled="disabled"
      :nudge-right="40"
      full-width
      lazy
      min-width="290px"
      offset-y
      ref="menu"
      transition="scale-transition"
      v-model="menu"
  >
    <v-text-field
      :disabled="disabled"
      :label="label"
      :required="required"
      :error-messages="errorMessages"
      @blur="onBlur"
      @input="onInput"
      @focus="dateInputFocused = true"
      prepend-icon="access_time"
      mask="##:##"
      slot="activator"
      v-bind="$attrs"
      :value="value"
    ></v-text-field>
    <v-time-picker
      v-if="menu"
      :disabled="disabled"
      :value="pickerTime"
      @input="onInput"
      format="24hr"
      no-title
      scrollable>
    </v-time-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';

export default {
  name: 'nx-time-picker',
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    format: {
      type: String,
      default: 'HH:mm',
    },
    errorMessages: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      dateInputFocused: false,
    };
  },
  computed: {
    pickerTime() {
      if (!this.value) return null;
      return moment(this.value, this.format).format('HH:mm');
    },
    focused() {
      return this.dateInputFocused || this.menu;
    },
  },
  watch: {
    focused(focused) {
      const event = focused ? 'focus' : 'blur';
      this.$emit(event, focused);
    },
  },
  methods: {
    onInput(newValue) {
      if (newValue && newValue.length === 4) {
        // Input masked value ##:##
        this.$emit('input', `${newValue.slice(0, 2)}:${newValue.slice(2, 4)}`);
      } else {
        this.$emit('input', newValue);
      }
    },
    onBlur(event) {
      this.dateInputFocused = false;
      const value = event.target.value;
      const isValid = value && /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(value);
      this.onInput(isValid ? value : null);
    },
  },
};
</script>
